<template>
	<div class="pb-3 bin-collection-schedule-item">
		<div class="row">
			<div class="col-12 col-lg-3 pl-0 pr-0 pr-lg-3 bin-collection-schedule-item-quantity">
				<div class="border bg-white d-flex align-content-center flex-wrap h-100">
					<p class="d-block w-100 text-center m-0 font-weight-bold count-bin">{{ binQuantity }}</p>
					<p class="d-block w-100 text-center m-0 text-muted font-md">Bin{{ binQuantity > 1 ? 's' : '' }}</p>
				</div>
			</div>
			<div class="col-12 col-lg-9 border bg-white bin-collection-schedule-item-details">
				<div class="row">
					<div class="col-12 col-lg-2 d-flex justify-content-center align-items-center pt-4 pb-lg-4">
						<img :src="iconPathReal + details.displayIcon" alt="" class="img-fluid" v-error-img-load>
					</div>
					<div class="col-12 col-lg-10 pt-4 pb-4 bin-collection-schedule-item-details-right">
						<h5 class="text-uppercase font-weight-bold font-md">{{ binSize + ' ' + details.displayName }}</h5>
						<div v-html="details.displayNote" class="text-muted mb-4 font-md" v-show="details.displayNote"></div>
						<div class="row">
							<div class="col-12 col-md-5">
								<div class="text-uppercase font-weight-bold frequency-head">frequency</div>
								<div class="frequency-content">{{ details.displayFrequency }}</div>
							</div>
							<div class="col-12 col-md-7">
								<div class="row">
									<div class="col-12 text-uppercase font-weight-bold next-coll-head pl-lg-0 pr-lg-0">
										next collection
									</div>
								</div>
								<div class="row">
									<div class="col-12 col-md-12 col-lg-6 next-coll-content pl-lg-0 pr-lg-0" v-for="nextCollection in details.items">
										<span class="text-capitalize">{{nextCollection.dayOfTheWeek.substr(0, 3)}}, </span>
										<span>{{ formatDate(nextCollection.nextCollectionDate) }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import DateNoTz from '../utils/DateNoTz';
	export default {
		props:{
			details: Object
		},
		data() {
			return {
				iconPath: process.env.MIX_APP_URL
			}
		},
		mounted() {
		},
		methods: {
			formatDate(schedule) {
				const d = new DateNoTz(schedule);
				return `${d.getDateWithZero()}-${d.getMonthDescShort()}-${d.getFullYear()}`
			}
		},
		computed: {
			singleItem() {
				return this.details.items[0];
			},
			binQuantity() {
				return parseInt((this.singleItem && this.singleItem.binQuantity) || 0);
			},
			binSize() {
				return ((this.singleItem && this.singleItem.binSize) || 0) + 'L';
			},
			iconPathReal() {
				return this.iconPath.indexOf('storage') === -1 ? `${this.iconPath}/storage/` : this.iconPath;
			}
		}
	}
</script>